import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const AnimatedBackground = ({ variant = 'light' }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    if (variant === 'violet') {
        // Rich violet aurora for login/register - DARK
        return (
            <div className="fixed inset-0 -z-10 overflow-hidden bg-gradient-to-br from-gray-950 via-violet-950/50 to-gray-950">
                <motion.div
                    className="absolute top-0 left-0 w-[500px] h-[500px] bg-violet-900/20 rounded-full blur-3xl"
                    animate={{
                        x: [0, 100, 0],
                        y: [0, 80, 0],
                        scale: [1, 1.2, 1],
                    }}
                    transition={{
                        duration: 30,
                        repeat: Infinity,
                        ease: 'easeInOut',
                    }}
                />
                <motion.div
                    className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-purple-900/15 rounded-full blur-3xl"
                    animate={{
                        x: [0, -120, 0],
                        y: [0, -80, 0],
                        scale: [1, 1.3, 1],
                    }}
                    transition={{
                        duration: 35,
                        repeat: Infinity,
                        ease: 'easeInOut',
                    }}
                />
                <motion.div
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-indigo-900/10 rounded-full blur-3xl"
                    animate={{
                        scale: [1, 1.4, 1],
                        rotate: [0, 180, 360],
                    }}
                    transition={{
                        duration: 40,
                        repeat: Infinity,
                        ease: 'easeInOut',
                    }}
                />
            </div>
        );
    }

    // Light variant for dashboard - adapts to theme
    return (
        <div className="fixed inset-0 -z-10 overflow-hidden bg-white dark:bg-[#0A0A0F] transition-colors duration-500">
            <motion.div
                className="absolute top-0 -left-40 w-96 h-96 bg-violet-200/20 dark:bg-violet-900/10 rounded-full blur-3xl"
                animate={{
                    x: [0, 100, 0],
                    y: [0, 50, 0],
                    scale: [1, 1.2, 1],
                }}
                transition={{
                    duration: 25,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />
            <motion.div
                className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-200/20 dark:bg-indigo-900/10 rounded-full blur-3xl"
                animate={{
                    x: [0, -100, 0],
                    y: [0, -50, 0],
                    scale: [1, 1.1, 1],
                }}
                transition={{
                    duration: 30,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />
            <motion.div
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-200/15 dark:bg-purple-900/8 rounded-full blur-3xl"
                animate={{
                    scale: [1, 1.3, 1],
                    rotate: [0, 180, 360],
                }}
                transition={{
                    duration: 35,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />
        </div>
    );
};

export default AnimatedBackground;
